import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  AdvancedPreparation,
  ListRequestOfBaseFilter,
  ListResponseOfAdvancedPreparation,
} from "services/KnowfullyAdminClient";

type SelectAdvancedPreparationProps = Omit<
  AutocompleteWithQueryProps<AdvancedPreparation>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectAdvancedPreparation = (props: SelectAdvancedPreparationProps) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const fetchedAdvancedPreparation = useQuery<ListResponseOfAdvancedPreparation>(
    ["advancedPreparation"],
    () =>
      skuService.getAdvancedPreparations(
        new ListRequestOfBaseFilter({
          sortField: "value",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="value"
      fetchedData={fetchedAdvancedPreparation}
      failMessage={t({ id: "selectAdvancedPreparationFetchFailed" })}
    />
  );
};

export default SelectAdvancedPreparation;
